// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"dam-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M8 21V10.1C8 7.89086 9.79086 6.1 12 6.1C14.2091 6.1 16 7.89086 16 10.1V21H20V10.1C20 5.62649 16.4735 2 12 2C7.52649 2 4 5.62649 4 10.1V21H8Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 21V10.1C8 7.89086 9.79086 6.1 12 6.1C14.2091 6.1 16 7.89086 16 10.1V21M8 21H4M8 21H9M3 21H4M4 21V10.1C4 5.62649 7.52649 2 12 2C16.4735 2 20 5.62649 20 10.1V21M20 21H21M20 21H16M16 21H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Dam1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'dam-1',
    ref,
    icon: element,
  },
));

Dam1Icon.displayName = 'Dam1Icon';

export default Dam1Icon;
